<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_5">Contents</h2>
<p class="first"><a href="#/Text/foreword#toc_marker-3-1">Foreword</a></p>
<p class="first"><a href="#/Text/acknowledgments#toc_marker-4-1">Acknowledgments</a></p>
<p class="first"><a href="#/Text/introduction#toc_marker-5-1">Introduction</a></p>
<p class="first"><a href="#/Text/PART1">PART ONE: God the Father</a></p>
<blockquote>
<p class="first"><a href="#/Text/ch1">1 Community Prayer</a></p>
<p class="first"><span href="#/Text/ch2" title="Link target outside of Sample">2 Creative Prayer</span></p>
<p class="first"><span href="#/Text/ch3" title="Link target outside of Sample">3 Work Prayer</span></p>
<p class="first"><span href="#/Text/ch4" title="Link target outside of Sample">4 Contemplative-Rest Prayer</span></p>
<p class="first"><span href="#/Text/ch5" title="Link target outside of Sample">5 Prayer of Confession</span></p>
<p class="first"><span href="#/Text/ch6" title="Link target outside of Sample">6 Blessing Prayer</span></p>
<p class="first"><span href="#/Text/ch7" title="Link target outside of Sample">7 Worship Prayer</span></p>
</blockquote>
<p class="first"><span href="#/Text/PART2" title="Link target outside of Sample">PART TWO: God the Son</span></p>
<blockquote>
<p class="first"><span href="#/Text/ch8" title="Link target outside of Sample">8 Daily Reflection Prayer—The Examen</span></p>
<p class="first"><span href="#/Text/ch9" title="Link target outside of Sample">9 The Lord’s Prayer</span></p>
<p class="first"><span href="#/Text/ch10" title="Link target outside of Sample">10 The Servant Prayer</span></p>
<p class="first"><span href="#/Text/ch11" title="Link target outside of Sample">11 Simplicity Prayer</span></p>
<p class="first"><span href="#/Text/ch12" title="Link target outside of Sample">12 Prayer in Play</span></p>
<p class="first"><span href="#/Text/ch13" title="Link target outside of Sample">13 Scripture Prayer—<i>Lectio Divina</i></span></p>
<p class="first"><span href="#/Text/ch14" title="Link target outside of Sample">14 Relinquishment Prayer</span></p>
<p class="first"><span href="#/Text/ch15" title="Link target outside of Sample">15 Forgiveness Prayer</span></p>
<p class="first"><span href="#/Text/ch16" title="Link target outside of Sample">16 Sacrament Prayer</span></p>
</blockquote>
<p class="first"><span href="#/Text/PART3" title="Link target outside of Sample">PART THREE: God the Holy Spirit</span></p>
<blockquote>
<p class="first"><span href="#/Text/ch17" title="Link target outside of Sample">17 Prayer Language—Tongues</span></p>
<p class="first"><span href="#/Text/ch18" title="Link target outside of Sample">18 Conversational Prayer</span></p>
<p class="first"><span href="#/Text/ch19" title="Link target outside of Sample">19 Breath Prayer</span></p>
<p class="first"><span href="#/Text/ch20" title="Link target outside of Sample">20 Healing Prayer</span></p>
<p class="first"><span href="#/Text/ch21" title="Link target outside of Sample">21 Meditative Prayer</span></p>
<p class="first"><span href="#/Text/ch22" title="Link target outside of Sample">22 Discernment Prayer</span></p>
<p class="first"><span href="#/Text/ch23" title="Link target outside of Sample">23 Watch Prayer</span></p>
<p class="first"><span href="#/Text/ch24" title="Link target outside of Sample">24 Rejoice Prayer</span></p>
<p class="first"><span href="#/Text/closing" title="Link target outside of Sample">Closing</span></p>
</blockquote>
<p class="first"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="first"><span href="#/Text/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
<p class="first"><span href="#/Text/relatedtitles" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d65e503c